
// These polyfills must be the first imports.
// Disabled the file with .prettierIgnore as
// @trivago/prettier-plugin-sort-imports doesn't respect // prettier-ignored
// https://github.com/trivago/prettier-plugin-sort-imports/issues/26
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import TagManager, { TagManagerArgs } from 'react-gtm-module';

import { APP_ROOT } from 'utils/constants';

import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initialise } from 'utils/logger';

ReactDOM.render(<App />, document.getElementById(APP_ROOT));

if (process.env.REACT_APP_DATA_DOG_TOKEN !== undefined) {
  initialise();
}

if (process.env.NODE_ENV === 'production') {
  const tagManagerArgs: TagManagerArgs = {
    gtmId: process.env.REACT_APP_GTMID || '',
    dataLayer: {
      deviceFingerprint: ''
    }
  };

  TagManager.initialize(tagManagerArgs);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (process.env.NODE_ENV !== 'production') {
  reportWebVitals(console.log);
}
